export default __webpack_public_path__ + "static/media/users-active.b5234c1a.svg";